export default "__VITE_ASSET__DAI7Z8Vq__"